// paypalService.js
import axios from './custom_axios';
import Cookies from 'js-cookie';

const API_URL = process.env.REACT_APP_API_URL;
// const RETURN_BANK_URL = process.env.REACT_APP_BANK_RETURN_URL;
// export const getAccessToken = async () => {
//     try {
//         const response = await fetch(`${API_URL}/api/accesstoken`, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//         });

//         if (!response.ok) {
//             const errorText = await response.text();
//             console.error(`Lỗi khi lấy Access Token: ${response.status} - ${errorText}`);
//             throw new Error("Lỗi khi lấy Access Token.");
//         }

//         const accessToken = await response.text();
//         return { access_token: accessToken };
//     } catch (error) {
//         console.error("Error in getAccessToken:", error);
//         throw error;
//     }
// };


// export const createPayPalOrder = async (invoiceID, totalAmount) => {
//     const total = (totalAmount / 24000).toFixed(2);
//     const totalVND = totalAmount;
//     const { access_token } = await getAccessToken();

//     if (!access_token) {
//         throw new Error("Access Token chưa sẵn sàng.");
//     }


//     try {
//         const response = await fetch('/v2/checkout/orders', {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${access_token}`,
//             },
//             body: JSON.stringify({
//                 intent: "CAPTURE",
//                 application_context: {
//                     return_url: `${RETURN_BANK_URL}/thank-you?invoiceID=${invoiceID}&total=${totalVND}&type=1`,
//                     cancel_url: `${RETURN_BANK_URL}/thank-you?invoiceID=${invoiceID}&total=${totalVND}&type=1`,
//                     brand_name: "Your Brand Name",
//                     locale: "en-US",
//                     user_action: "PAY_NOW",
//                 },
//                 purchase_units: [
//                     {
//                         amount: {
//                             currency_code: "USD",
//                             value: total,
//                         },
//                         invoice_id: invoiceID,
//                         description: `Thanh toán giỏ hàng - Invoice ID: ${invoiceID}`,
//                     },
//                 ],
//             }),
//         });

//         console.log("PayPal Response Status:", response.status);

//         if (!response.ok) {
//             const errorData = await response.json();
//             console.error("Lỗi API PayPal:", errorData);
//             throw new Error("Lỗi khi tạo đơn hàng PayPal.");
//         }

//         const data = await response.json();
//         console.log("Order Data:", data);

//         const approvalUrl = data.links.find((link) => link.rel === "approve")?.href;
//         if (!approvalUrl) {
//             throw new Error("Không tìm thấy URL xác nhận từ PayPal.");
//         }

//         return approvalUrl;
//     } catch (error) {
//         console.error("Error in createPayPalOrder:", error);
//         throw error;
//     }
// };
// export const createPayPalOrder = async (invoiceID, totalAmount) => {
//     const response = await fetch(`${API_URL}/api/create-paypal-order`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ invoiceID, totalAmount }),
//     });

//     if (!response.ok) {
//         throw new Error('Failed to create order');
//     }

//     const data = await response.json();
//     return data.approvalUrl;
// };

const createPayPal = async (invoiceID, total, invoiceType, order_detail_id, packagenew, promocode) => {
    const roundedTotal = parseFloat(total).toFixed(2);

    const token = Cookies.get("Token");
    const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/payment/paypal/create-url`,
        {
            invoice_id: invoiceID,
            total: roundedTotal,
            invoice_type: invoiceType,
            order_detail_id: order_detail_id,
            packagenew: packagenew,
            promocode: promocode
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        }
    );
    if (response.data.approval_url) {
        return response.data.approval_url;
    } else {
        throw new Error("Failed to create PayPal order.");
    }

};

export { createPayPal }
